<script lang="ts">
	import type { HTMLAttributes } from 'svelte/elements';

	interface Props extends HTMLAttributes<HTMLDivElement> {
		heightLabel: string;
		labelClass?: string;
	}

	let { heightLabel, labelClass = 'bg-stone-4' }: Props = $props();
</script>

<div class="h-full w-4 border-y-[1px] border-brown-1">
	<div class="relative flex h-full flex-col items-center">
		<div class="h-[28%] w-[1px] border-r-[1px] border-dashed border-brown-1"></div>
		<div class="h-[72%] w-[1px] bg-brown-1"></div>
		<div class={['absolute top-1/2 -translate-y-1/2 select-none py-1 text-brown-1', labelClass]}>
			{heightLabel}”
		</div>
	</div>
</div>
